import type { ReadReferenceType } from '@readme/api/src/mappings/page/reference/types';
import type { PageClientSide } from '@readme/backend/models/page/types';
import type { OASDocument } from 'oas/types';
import type { PartialDeep } from 'type-fest';

export function normalizeGitDocToMongo(data?: ReadReferenceType['data']) {
  if (!data) return undefined;

  return {
    _id: data.uri,
    api: {
      method: data.api.method as PageClientSide['api']['method'],
      url: data.api.path,
      params: [],
    },
    body: data.content.body ?? undefined,
    deprecated: data.state === 'deprecated',
    excerpt: data.content.excerpt ?? undefined,
    slug: data.slug,
    swagger: {
      path: data.api.path,
    },
    title: data.title,
    type: data.type as PageClientSide['type'],
  } satisfies PartialDeep<PageClientSide>;
}

export function normalizeGitOasToMongo(data: ReadReferenceType['data']) {
  return {
    _id: data.api.uri,
    ...(data.api.schema as OASDocument),
  };
}
